import { Modal } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import { axiosbaseurl } from "../config"
import moment from "moment"
import React, { useEffect, useMemo, useState } from "react"
import { FaChevronLeft, FaChevronRight, FaEye } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Loader from "./Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"
import { RiArrowUpDownFill } from "react-icons/ri"

const Contact = () => {
  document.title = "Contact Enquiry | Return First Investments"

  const { checkAccess } = usePermissionData()

  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])
  const [CurrentItem, setCurrentItem] = useState({})
  const [sortConfig, setSortConfig] = useState({
    key: "created_at",
    direction: "descending",
  })

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`contact-enquiry`)
      if (response?.data?.success) {
        setUsers(response?.data?.data)
        setData(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(
      session =>
        session.senderName
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.senderEmail
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session?.contactNumber
          ?.toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const [Modal1, setModal] = useState(false)

  const handleModal = item => {
    setCurrentItem(item)
    setModal(true)
  }

  const sortedData = useMemo(() => {
    let sortableItems = [...Data]

    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        let aValue = a[sortConfig.key]
        let bValue = b[sortConfig.key]

        // Special handling for date
        if (sortConfig.key === "created_at") {
          aValue = new Date(aValue)
          bValue = new Date(bValue)
        } else {
          if (typeof aValue === "string") aValue = aValue.toLowerCase()
          if (typeof bValue === "string") bValue = bValue.toLowerCase()
        }

        if (aValue < bValue)
          return sortConfig.direction === "ascending" ? -1 : 1
        if (aValue > bValue)
          return sortConfig.direction === "ascending" ? 1 : -1
        return 0
      })
    }

    return sortableItems
  }, [Data, sortConfig])

  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(6, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Contact Enquiry"} />

            <div className="card p-2 py-3">
              <div className="d-flex align-items-center">
                <div className="search-box position-relative">
                  <input
                    className="form-control form-control1 ps-6"
                    placeholder="Search Enquiry"
                    onChange={filterByName}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
                <select
                  className="form-select form-select1 ms-3 fs-6 rounded-5"
                  value={items_perpage}
                  onChange={e => setItemsPerPage(e.target.value)}
                  style={{ width: "110px" }}
                >
                  <option value="5">Show 5</option>
                  <option value="10">Show 10</option>
                  <option value="20">Show 20</option>
                  <option value="30">Show 30</option>
                </select>
              </div>
              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("senderName")}
                      >
                        Sender Name{" "}
                        {sortConfig.key === "senderName" ? (
                          sortConfig.direction === "ascending" ? (
                            "🔼"
                          ) : (
                            "🔽"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("senderEmail")}
                      >
                        Email Address{" "}
                        {sortConfig.key === "senderEmail" ? (
                          sortConfig.direction === "ascending" ? (
                            "🔼"
                          ) : (
                            "🔽"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("contactNumber")}
                      >
                        Phone Number{" "}
                        {sortConfig.key === "contactNumber" ? (
                          sortConfig.direction === "ascending" ? (
                            "🔼"
                          ) : (
                            "🔽"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.senderName}</td>
                        <td>{item?.senderEmail}</td>
                        <td>{item?.contactNumber}</td>
                        <td>
                          <button
                            className="btn Edit-Button"
                            onClick={() => handleModal(item)}
                          >
                            <FaEye /> View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="text-center">
                {final_data?.length < 1
                  ? "No enquiry available at this moment !"
                  : ""}
              </div>
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {Data?.length} enquiries.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Modal
          open={Modal1}
          onCancel={() => setModal(false)}
          footer={false}
          title="Enquiry Description"
          width={700}
          bodyStyle={{ padding: "0" }}
          centered
        >
          <div className="bg-gradientt p-4">
            <table
              className="table Cutom-popup-table"
              style={{ verticalAlign: "middle" }}
            >
              <tbody>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Received At</th>
                  <td className="p-3">
                    {moment(CurrentItem?.created_at).format(
                      "DD MMMM YYYY | HH:mm A"
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Subject</th>
                  <td className="p-3">{CurrentItem?.subject}</td>
                </tr>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Message</th>
                  <td className="p-3">{CurrentItem?.message}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Contact
